var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-auto"},[(_vm.account)?[(!_vm.account.PasswordSet)?_c('SetPassword'):(!_vm.account.Activated)?_c('AccountActivation',{attrs:{"email":_vm.account.Email}}):_c('Workspaces',{attrs:{"redirect":""}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }